module.exports = __webpack_public_path__ + "media/src/images/bg/bg1-91f3332931152273029ae5274433936e.jpg";